import { render } from "./NexusIntegration.vue?vue&type=template&id=3c457762"
import script from "./NexusIntegration.vue?vue&type=script&lang=js"
export * from "./NexusIntegration.vue?vue&type=script&lang=js"

import "./NexusIntegration.vue?vue&type=style&index=0&id=3c457762&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__